import { render, staticRenderFns } from "./CropImage.vue?vue&type=template&id=524be39c&scoped=true&"
import script from "./CropImage.vue?vue&type=script&lang=js&"
export * from "./CropImage.vue?vue&type=script&lang=js&"
import style0 from "./CropImage.vue?vue&type=style&index=0&id=524be39c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524be39c",
  null
  
)

export default component.exports